export function waitForObject(key) {
    return new Promise((resolve) => {
        const intervalId = setInterval(() => {
            if (key in window) {
                clearInterval(intervalId);
                resolve(window[key]);
            }
        }, 100);
    });
}
